import React from 'react';
import { makeStyles } from '@material-ui/styles';
import NgReportsTable from './other-reports/NgReportsTable';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const NgReports = () => {
  const classes = useStyles();

  return (
    <div className={ classes.root }>
      <NgReportsTable />
    </div>
  );
};

export default NgReports;
